module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.svg?a2a1f732cc34764c684ed521c6f3327c";